import React from "react";
import Button from "../../../../component/button/Button";
import { useSelector } from "react-redux";
import ShareJob from "./ShareJob";
import useClientConfig from "../../../../config/careers/clientConfig";


const NoJobMatch = (props: any) => {
    const questionId = useSelector((stete: any) => { return stete?.careers?.getQuestionId; });
    const cliendConfig = useSelector((state: any) => state.careers.cliendConfig);
    const noJobLang = cliendConfig?.data?.data?.clientSettings?.languageSettings;
    const noJobLangLabels = noJobLang?.noJobsSection?.[0];
    const {clientAssetsLink} = useClientConfig();

    const { navigateToJob, navigateToJobAlerts, routeParams, location, langLabels } = props;

    return (
        <>
            {(questionId?.status === 200  || cliendConfig?.data?.data?.clientSettings?.showJobAlertButton === 1) ? (
                
                <div className={"job-search-box "}>
                    <div className="btn-section">
                        <div className="text-center">
                            <h2 className="job-view-text">{noJobLangLabels?.noJobs}</h2>                        
                            <p className="infi-text" dangerouslySetInnerHTML={{ __html: noJobLangLabels?.noJobsText }} ></p>
                        </div>
                        {questionId?.status === 200 ?
                            <Button
                                clasName="btn-new btn-primary-new w-100 justify-content-center"
                                label={noJobLangLabels?.registerYourInterest}
                                onClick={navigateToJob} />
                            : ""}

                        { (cliendConfig?.data?.data?.clientSettings?.showJobAlertButton === 1) ? (
                        <Button
                            clasName="btn-new btn-primary-new w-100 justify-content-center"
                            label={noJobLangLabels?.jobAlerts}
                            onClick={navigateToJobAlerts}  />
                        ) : ""}
                    </div>
                    <ShareJob cliendConfig={cliendConfig} routeParams={routeParams} location={location} />
                </div>
                 
            ) : ""}

            { (cliendConfig?.data?.data?.clientSettings?.clientSiteSettings?.templateName === "mcc") && <div className="bestEmployer"><img src={clientAssetsLink+"/best_employer.png"} /></div> }
        </>
    );
};

export default NoJobMatch;